import type { Student } from "types/Student";

export const isStudentGraduated = (student: Student): boolean => {
  try {
    if (!student?.graduation_date) return false;

    const [year, month, day] = student.graduation_date
      .split("-")
      .map(Number);

    if (!year || !month || !day) return false;

    const graduationDate = new Date(year, month - 1, day);
    if (Number.isNaN(graduationDate.getTime())) return false;

    // Treat the selected graduation month as inclusive and only mark
    // the student as graduated from the first day of the following month.
    const startOfMonthAfterGraduation = new Date(
      graduationDate.getFullYear(),
      graduationDate.getMonth() + 1,
      1
    );

    const today = new Date();
    const normalizedToday = new Date(
      today.getFullYear(),
      today.getMonth(),
      today.getDate()
    );

    return normalizedToday >= startOfMonthAfterGraduation;
  } catch (error) {
    console.warn("Error determining graduation status:", error);
    return false;
  }
};

export default isStudentGraduated;
